import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

// The panel's rows, shared with the Deal page's Amount Due breakdown popover.
// Zero-amount rows are left out — they only clutter the breakdown.
export const getAmountDueAtSigningRows = (pdfData) => {
    // MarketScan sends the first payment waiver as a positive item, though it is a credit.
    const items = (pdfData.amount_due_at_signing_breakdown || [])
        .map((v) => ({label: v.name, amount: v.name === 'First Monthly Payment Waiver Rebate' ? -Number(v.amount) : Number(v.amount)}))
        .filter((v) => v.amount)

    // MarketScan sometimes already counts the cap reduction's tax in the
    // inception fees, as a "Down Pmt. Tax" item of the same amount.
    const capReductionTax = Number(pdfData.cap_reduction_cash_tax)
    const isTaxInFees = items.some((v) => v.label.startsWith('Down Pmt. Tax') && v.amount === capReductionTax)

    const adjustments = [
        // Signed as a cap cost reduction (negative) for the Cap Cost panel; here it is cash paid.
        {label: 'Cap Reduction (Cash)', amount: -Number(pdfData.cap_reduction_cash)},
        {label: 'Cap Reduction Cash Tax', amount: isTaxInFees ? 0 : capReductionTax},
        {label: 'Capitalized Inception Fees', amount: -Number(pdfData.capitalized_inception_fees)},
        {label: 'Rebate as Drive Off', amount: -Number(pdfData.rebate_as_drive_off)},
        {label: 'Trade as Drive Off', amount: -Number(pdfData.trade_as_drive_off)},
    ].filter((v) => v.amount)

    return {
        items,
        totalInceptionFees: Number(pdfData.total_inception_fees),
        adjustments,
        totalDriveOff: Number(pdfData.cash_due_on_delivery),
    }
}

export const AmountDueAtSigningPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const rows = getAmountDueAtSigningRows(pdfData)

    return (
        <Panel title="Amount Due at Signing">
            {rows.items.map((v, i) => (
                <DataRow key={i} label={v.label} value={v.amount.toDollarFormat()}/>
            ))}
            <DataRow
                label="Total Inception Fees"
                value={rows.totalInceptionFees.toDollarFormat()}
                isTotal
                variant="bold"
            />
            {rows.adjustments.map((v) => (
                <DataRow key={v.label} label={v.label} value={v.amount.toDollarFormat()}/>
            ))}
            <DataRow
                label="Total Drive Off"
                value={rows.totalDriveOff.toDollarFormat()}
                isTotal
                variant="blue"
                isLast
            />
        </Panel>
    )
}
